import React, { useState, useEffect } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, FormControlLabel, Checkbox, Typography } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';

const CreateSpecificLink = ({ render, setRender }) => {
    const [open, setOpen] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [url, setURL] = useState('');
    const [limitPerDay, setLimitPerDay] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [attachCategory, setAttachCategory] = useState(false);

    const [errors, setErrors] = useState({});

    const URL = process.env.REACT_APP_BASE_URL;
    const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"));

    const handleClickOpen = () => {
        setOpen(true);
        fetchCategories();
    };

    const handleClose = () => {
        setOpen(false);
        setURL('');
        setLimitPerDay('');
        setKeyword('')
        setSelectedCategory('');
        setAttachCategory(false); 
    };

    const validateFields = () => {
        let tempErrors = {};
        let errorMessages = [];

        if (attachCategory && !selectedCategory) {
            tempErrors.selectedCategory = "Please select a category or uncheck 'Attach to Category'";
            errorMessages.push("Please select a category or uncheck 'Attach to Category'");
        }

        setErrors(tempErrors);
        return errorMessages.length === 0 ? true : errorMessages;
    };
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${URL}specific-link-category/all`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setCategories(response.data);
        } catch (error) {
            toast.error('Failed to fetch categories');
            console.error('Error fetching categories:', error);
        }
    };

    // Handle form submission
    const handleSubmit = async () => {
        const validationErrors = validateFields();

        if (validationErrors !== true) {
            validationErrors.forEach((error) => {
                toast.error(error);
            });
            return;
        }
        const specificLinkData = {
            url,
            keyword,
            limitToday: limitPerDay
        };

        if (attachCategory && selectedCategory) {
            specificLinkData.category = selectedCategory;
        }

        try {
            const response = await axios.post(`${URL}specific-link/create`, specificLinkData ,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (ToasterToggle) {
                toast.success(response.data.message || 'Specific Link created successfully');
            }
            setRender((prev) => !prev);
            handleClose();
        } catch (error) {
            toast.error('Failed to create Specific Link');
            console.error('Error creating Specific Link:', error);
        }
    };

    return (
        <div>
            <Button style={{ margin: "2rem 3rem" }} variant="contained" color="primary" onClick={handleClickOpen}>
                Create Specific Link
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Create a New Specific Link</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Keyword"
                        fullWidth
                        variant="outlined"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Link URL"
                        fullWidth
                        variant="outlined"
                        value={url}
                        onChange={(e) => setURL(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Limit Per Day"
                        fullWidth
                        variant="outlined"
                        value={limitPerDay}
                        onChange={(e) => setLimitPerDay(e.target.value)}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={attachCategory}
                                onChange={(e) => setAttachCategory(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Attach to Category"
                    />

                    {attachCategory && (
                        <TextField
                            select
                            label="Select Category"
                            fullWidth
                            margin="dense"
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                        >
                            {categories.map((category) => (
                                <MenuItem key={category._id} value={category._id}>
                                    {category.categoryName}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
};

export default CreateSpecificLink;

